import { Link } from "react-router-dom";

const LINK_CLS = "text-brand underline underline-offset-2 hover:text-brand-hover";
// Interner Link: Sprachpräfix abschneiden – der Router hängt die Sprache selbst an (sonst /es/es/…)
const stripLang = (p) => p.replace(/^\/(en|es|nl|pl|fr|it)(?=\/|$)/, "") || "/";

/** Wandelt [Text](/pfad) bzw. [Text](https://…) und **fett** in React-Knoten um. Zeilenumbrüche bleiben (whitespace-pre-line beim Container). */
export const richText = (str, extra) => {
  if (!str) return str;
  return String(str).split(/(\[[^\]]+\]\([^)\s]+\)|\*\*[^*]+\*\*)/g).flatMap((seg, k) => {
    const link = seg.match(/^\[([^\]]+)\]\(([^)\s]+)\)$/);
    if (link) {
      return [/^https?:\/\//.test(link[2])
        ? <a key={k} href={link[2]} target="_blank" rel="noreferrer" className={LINK_CLS}>{link[1]}</a>
        : <Link key={k} to={stripLang(link[2])} className={LINK_CLS} data-testid="rich-link">{link[1]}</Link>];
    }
    const bold = seg.match(/^\*\*([^*]+)\*\*$/);
    if (bold) return [<strong key={k}>{bold[1]}</strong>];
    return extra ? extra(seg, k) : [seg];
  });
};
